import React from 'react';

import Component from './component';
import fixtures from './fixtures';
import transform from './transformer';

const FormRealtorCards = (props) => <Component {...transform(props)} />;

export default FormRealtorCards;

export { Component as component, fixtures, transform as transformer };
